
export enum CustomerAgentRole {
    user = "user",
    superUser = "superUser",
    adminUser = "adminUser",
}
export enum InventoryItemStatus {
    available = "available",
    rentedOut = "rentedOut",
    inspection = "inspection",
    recycled = "recycled",
    lost = "lost",
    removed = "removed",
    sold = "sold",
    picked = "picked",
    inTransit = "inTransit",
}
export enum InventoryCountingSessionStatus {
    started = "started",
    completed = "completed",
}
export enum DamageType {
    patch = "patch",
    rippedEars = "rippedEars",
    twoPatch = "twoPatch",
    hole = "hole",
    other = "other",
}
export enum AccountingSystemInvoiceStatus {
    pendingExport = "pendingExport",
    exportSucceeded = "exportSucceeded",
    exportFailed = "exportFailed",
}
export enum MaintenanceActivityType {
    repair = "repair",
    cleaning = "cleaning",
    recycle = "recycle",
}
export enum NoteType {
    info = "info",
    alert = "alert",
}
export enum OrderType {
    rentalOrder = "rentalOrder",
    salesOrder = "salesOrder",
}
export enum RentalOrderStatus {
    new = "new",
    confirmed = "confirmed",
    fulfilled = "fulfilled",
    canceled = "canceled",
    completed = "completed",
}
export enum SalesOrderStatus {
    new = "new",
    confirmed = "confirmed",
    fulfilled = "fulfilled",
    canceled = "canceled",
    invoiced = "invoiced",
}
export enum PickListStatus {
    new = "new",
    started = "started",
    completed = "completed",
    canceled = "canceled",
}
export enum ProductPriceListStatus {
    draft = "draft",
    published = "published",
}
export enum RentalStatus {
    started = "started",
    ended = "ended",
    canceled = "canceled",
}
export enum ReportParameterType {
    calendarMonth = "calendarMonth",
    order = "order",
    customer = "customer",
}
export enum ServiceType {
    order = "order",
    maintenanceActivity = "maintenanceActivity",
}
